import type ReminderOptionType from '../helpers/ReminderOptionType';
import getAllDayReminderOption from './getAllDayReminderOption';
import getNonAllDayReminderOption from './getNonAllDayReminderOption';
import isSelectedReminderFound from './isSelectedReminderFound';
import addReminderToOptions from './addReminderToOptions';

export default function createReminderDropdownOptions(
    isAllDay: boolean,
    selectedReminderTimeInMinutes: number,
    includeNoReminder: boolean
): ReminderOptionType[] {
    let reminderDropdownOptions = isAllDay
        ? getAllDayReminderOption(includeNoReminder)
        : getNonAllDayReminderOption(includeNoReminder);

    // find and add reminder that is not in React default reminders set
    if (selectedReminderTimeInMinutes !== -1) {
        let selectedReminderFound = isSelectedReminderFound(
            selectedReminderTimeInMinutes,
            reminderDropdownOptions
        );
        if (!selectedReminderFound) {
            reminderDropdownOptions = addReminderToOptions(
                isAllDay,
                selectedReminderTimeInMinutes,
                reminderDropdownOptions
            );
        }
    }

    return reminderDropdownOptions;
}
